import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { getPolyglot } from '../../../../i18n';
import StoerkIdAPI from '../../../../redux/stoerkID/StoerkIdAPI';
import { WorkspaceAPI } from '../../../../redux/stoerkID/StoerkIdAPI.model';

interface ParentWorkspaceInfoProps {
  workspace: WorkspaceAPI;
}

function ParentWorkspaceInfo({ workspace }: ParentWorkspaceInfoProps) {
  const polyglot = getPolyglot();

  const parentId = workspace.parentId;
  if (!parentId) return null;

  return <ParentInfoContent parentId={parentId} />;
}

function ParentInfoContent({ parentId }: { parentId: string }) {
  const polyglot = getPolyglot();

  const { data: parentWorkspace, isLoading } =
    StoerkIdAPI.useGetWorkspaceQuery(parentId);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" p={2}>
        <CircularProgress size="1.5em" />
      </Box>
    );
  }

  if (!parentWorkspace) return null;

  return (
    <Box>
      <Typography variant="h2" mb={1}>
        {polyglot.t('stoerk_id.parent_workspace.title')}
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={2}>
        {polyglot.t('stoerk_id.parent_workspace.description')}
      </Typography>
      <Box display="flex" gap={4} flexWrap="wrap">
        <Box>
          <Typography variant="subtitle2" color="text.secondary">
            {polyglot.t('stoerk_id.parent_workspace.company_name')}
          </Typography>
          <Typography variant="body1">{parentWorkspace.name || '-'}</Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2" color="text.secondary">
            {polyglot.t('stoerk_id.parent_workspace.workspace_id')}
          </Typography>
          <Typography variant="body1">{parentId}</Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default ParentWorkspaceInfo;
